import styled from "styled-components";

export const ProjectContainer = styled.div`
  color: #fff;
  background: ${({ lightBg }) => (lightBg ? "#fefefa" : "#2b2e46")};

  @media screen and (max-width: 850px) {
    padding: 85px 0;
  }

  @media screen and (max-width: 456px) {
    padding: 70px 0;
  }
`;

export const ProjectWrapper = styled.div`
  display: grid;
  z-index: 1;
  // height: calc(100vh - 80px);
  width: 100%;
  max-width: 1100px;
  margin-right: auto;
  margin-left: auto;
  //padding: 0 24px;
  padding: 50px 24px;
  justify-content: center;

  @media screen and (max-width: 850px) {
    padding: 0 10px;
    height: 100%;
  }
`;

export const ProjectRow = styled.div`
  display: grid;
  grid-auto-columns: minmax(auto, 1fr);
  align-items: center;
  grid-template-areas: ${({ imgStart }) => (imgStart ? `"col2 col1"` : `"col1 col2"`)};

  @media screen and (max-width: 856px) {
    grid-template-areas: ${({ imgStart }) => (imgStart ? `"col1" "col2"` : `"col1 col1" "col2 col2"`)};
  }
`;

export const Column1 = styled.div`
  margin-bottom: 15px;
  padding: 0 15px;
  grid-area: col1;
`;

export const Column2 = styled.div`
  margin-bottom: 15px;
  padding: 0 15px;
  grid-area: col2;
`;

export const TextWrapper = styled.div`
  max-width: 600px;
  padding-top: 0;
`;

export const TopLine = styled.p`
  color: #ffb400;
  font-size: 16px;
  line-height: 16px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  margin-bottom: 16px;
`;

export const Heading = styled.h1`
  margin-bottom: 24px;
  font-size: 42px;
  line-height: 1.1;
  font-weight: 600;

  color: ${({ lightText }) => (lightText ? "#fefefa" : "#1b1b1b")};

  @media screen and (max-width: 1368px) {
    font-size: 40px;
  }

  @media screen and (max-width: 1156px) {
    font-size: 34px;
  }

  @media screen and (max-width: 950px) {
    font-size: 32px;
  }

  @media screen and (max-width: 850px) {
    font-size: 30px;
  }
`;

export const Subtitle = styled.p`
  max-width: 440px;
  margin-bottom: 35px;
  font-size: 18px;
  line-height: 24px;
  color: ${({ lightTextSub }) => (lightTextSub ? "#fefefa" : "#1b1b1b")};

  @media screen and (max-width: 850px) {
    font-size: 16px;
  }
`;

export const ImgWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Img = styled.img`
  margin: 0 0 10px 0;
  padding-right: 0;
  max-width: 100%;
  display: block;
  filter: saturate(60%);

  @media screen and (max-width: 856px) {
    margin: 0;
  }
`;
